__turbopack_context__.v({
  "descriptionTitle": "PromotionBottomDescription-module-scss-module__VgCClG__descriptionTitle",
  "promotionBottomDescription": "PromotionBottomDescription-module-scss-module__VgCClG__promotionBottomDescription",
  "text": "PromotionBottomDescription-module-scss-module__VgCClG__text",
  "text_closed": "PromotionBottomDescription-module-scss-module__VgCClG__text_closed",
});
